import { render } from "./EmptyLayout.vue?vue&type=template&id=958ed004"
const script = {}

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__